import defaultPropertyImage from 'assets/images/default-property-image.png';

export const getPropertyImage = (src: string) => {
  return src ? src : defaultPropertyImage;
};
